export function getId() {
    const { stack } = new Error()
    return stack
}
